var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 39,
    viewBox: "0 0 52 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 0C2.18359 0 0 2.18359 0 4.875C0 6.40859 0.721094 7.85078 1.95 8.775L24.05 25.35C25.2078 26.2133 26.7922 26.2133 27.95 25.35L50.05 8.775C51.2789 7.85078 52 6.40859 52 4.875C52 2.18359 49.8164 0 47.125 0H4.875ZM0 11.375V32.5C0 36.0852 2.91484 39 6.5 39H45.5C49.0852 39 52 36.0852 52 32.5V11.375L29.9 27.95C27.5844 29.6867 24.4156 29.6867 22.1 27.95L0 11.375Z",
    fill: "#BF96FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.c0acfcc0eb11b61ebe90a3ab1d31a02e.svg";
export { ForwardRef as ReactComponent };